import invoiceBuyerPage from './view/invoiceBuyer.html'

function lengthForString(temp) {
    let len = 0
    temp = $.trim(temp)
    for (let i = 0; i < temp.length; i += 1) {
        const c = temp.charCodeAt(i)
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
            len += 1
        } else {
            len += 2
        }
    }
    return len
}

export default {
    bindings: {
        invoice: '=', // 对应发票
        detailMode: '<?',
    },
    controllerAs: 'ctrl',
    template: invoiceBuyerPage,
    controller: ['$http', 'logger', 'globalFn', function invoiceBuyerCtrl($http, logger, globalFn) {
        this.qryCustNameList = function qryCustNameList($item) {
            if (lengthForString($item) > 100) {
                this.invoice.custName = ''
                logger.logError('购方名称长度不合法')
                return null
            }

            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, $item).then((response) => response.data.value.map((item) => $.extend({}, {
                custCodeAndcustName: `${item.customerName} ${item.creditCode}`,
            }, item)))
        }
        this.selectCust = function selectCust($item) {
            this.invoice.custName = $item.customerName
            this.invoice.custCreditCode = $item.creditCode
            this.invoice.custAddress = $item.businessAddress || $item.registerAddress
            this.invoice.custPhone = $item.phone
            this.invoice.custBank = $item.bank
            this.invoice.custBankAccount = $item.bankAccount
            this.invoice.custCode = $item.customerCode
            this.invoice.creditType = $item.taxplayerType
            this.invoice.custEmail = $item.email
            this.invoice.custMobile = $item.mobile
        }
        this.taxNoChange = function taxNoChange() {
            if (this.invoice.custCreditCode !== '' && !globalFn.checkTax(this.invoice.custCreditCode)) {
                logger.logError('购方纳税人识别号格式错误！')
                this.invoice.custCreditCode = ''
            }
        }
    }],
}



// WEBPACK FOOTER //
// ./src/components/invoiceRelated/invoiceBuyer.js